export function schema_zip() {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
			action: {
				type: "string",
				title: "Mode",
				enum: ["zip", "unzip", "unzip_csv", "csv"],
				default: "fichiers",
			},
			name: {
				type: "string",
				title: "Nom du zip",
			},
			column_folder: {
				type: "string",
				title: "Colonne dossier (si csv)",
			},
			column_url: {
				type: "string",
				title: "Colonne url (si csv)",
			},
			column_name: {
				type: "string",
				title: "Colonne des noms (si csv)",
			},
		},
	};
}
